var _Timer_instances, _Timer_autoReset, _Timer_enabled, _Timer_interval, _Timer_intervalPointer, _Timer_elapsedEvent, _Timer_createInterval, _Timer_destroyInterval;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Event from './Events/Event';
import ArgumentException from './Exceptions/ArgumentException';
export default class Timer {
    constructor(interval = 100) {
        _Timer_instances.add(this);
        _Timer_autoReset.set(this, void 0);
        _Timer_enabled.set(this, void 0);
        _Timer_interval.set(this, void 0);
        _Timer_intervalPointer.set(this, void 0);
        _Timer_elapsedEvent.set(this, void 0);
        if (interval < 0) {
            throw new ArgumentException("interval", "interval must be greater than 0");
        }
        interval = Math.ceil(interval);
        if (interval < 0) {
            throw new ArgumentException("interval", "interval must be greater than 0");
        }
        __classPrivateFieldSet(this, _Timer_autoReset, true, "f");
        __classPrivateFieldSet(this, _Timer_enabled, false, "f");
        __classPrivateFieldSet(this, _Timer_interval, Math.round(interval), "f");
        __classPrivateFieldSet(this, _Timer_elapsedEvent, new Event(), "f");
    }
    get onElapsed() {
        return __classPrivateFieldGet(this, _Timer_elapsedEvent, "f");
    }
    /** Gets a Boolean indicating whether the Timer should raise the Elapsed event only once(false) or repeatedly(true). */
    get autoReset() {
        return __classPrivateFieldGet(this, _Timer_autoReset, "f");
    }
    /** Sets a Boolean indicating whether the Timer should raise the Elapsed event only once(false) or repeatedly(true). */
    set autoReset(value) {
        __classPrivateFieldSet(this, _Timer_autoReset, value, "f");
    }
    /** Gets a value indicating whether the Timer should raise the Elapsed event. */
    get enabled() {
        return __classPrivateFieldGet(this, _Timer_enabled, "f");
    }
    /** Sets a value indicating whether the Timer should raise the Elapsed event. */
    set enabled(value) {
        // multiple call protection
        if (__classPrivateFieldGet(this, _Timer_enabled, "f") === value) {
            return;
        }
        __classPrivateFieldSet(this, _Timer_enabled, value, "f");
        if (__classPrivateFieldGet(this, _Timer_enabled, "f")) {
            __classPrivateFieldGet(this, _Timer_instances, "m", _Timer_createInterval).call(this);
        }
        else {
            __classPrivateFieldGet(this, _Timer_instances, "m", _Timer_destroyInterval).call(this);
        }
    }
    /** Gets the interval, expressed in milliseconds, at which to raise the Elapsed event. */
    get interval() {
        return __classPrivateFieldGet(this, _Timer_interval, "f");
    }
    /** Sets the interval, expressed in milliseconds, at which to raise the Elapsed event. */
    set interval(value) {
        __classPrivateFieldSet(this, _Timer_interval, value, "f");
    }
    /** Starts raising the Elapsed event by setting Enabled to true. */
    start() {
        this.enabled = true;
    }
    /** Stops raising the Elapsed event by setting Enabled to false. */
    stop() {
        this.enabled = false;
    }
    dispose() {
        this.stop();
    }
}
_Timer_autoReset = new WeakMap(), _Timer_enabled = new WeakMap(), _Timer_interval = new WeakMap(), _Timer_intervalPointer = new WeakMap(), _Timer_elapsedEvent = new WeakMap(), _Timer_instances = new WeakSet(), _Timer_createInterval = function _Timer_createInterval() {
    __classPrivateFieldSet(this, _Timer_intervalPointer, setInterval(() => {
        // has been disabled but the interval wasn't cancelled or, disable after this run
        if (!__classPrivateFieldGet(this, _Timer_enabled, "f") || !this.autoReset) {
            __classPrivateFieldGet(this, _Timer_instances, "m", _Timer_destroyInterval).call(this);
            return;
        }
        // disable after this run
        if (!this.autoReset) {
            __classPrivateFieldSet(this, _Timer_enabled, false, "f");
            __classPrivateFieldGet(this, _Timer_instances, "m", _Timer_destroyInterval).call(this);
        }
        __classPrivateFieldGet(this, _Timer_elapsedEvent, "f").invoke(this, { signalTime: Date.now() });
    }, this.interval), "f");
}, _Timer_destroyInterval = function _Timer_destroyInterval() {
    if (__classPrivateFieldGet(this, _Timer_intervalPointer, "f") !== undefined) {
        clearInterval(__classPrivateFieldGet(this, _Timer_intervalPointer, "f"));
        __classPrivateFieldSet(this, _Timer_intervalPointer, undefined, "f");
    }
};
